import { BaseDto } from './base.dto';
import { CartRequestDto } from './cartRequest.dto';

export class OrderPaymentDetailsDataDto extends BaseDto {
  cart: CartRequestDto;
  userAuth?: any;
  bearerToken?: string;
}
